export { getLocaleByLanguage } from "./getLocaleByLanguage";
